import React from 'react';
import { Text, TouchableOpacity, View } from '@applane/react-core-components';
import { Table } from '../../../app-components';
import { ROUTES } from '../../../Lib/constants';
import { listAllUri } from '../../../Queries/avGenerationHistory';
import vars from '../../../theme/vars';
import { shorten } from '../../../Lib/helpers';

const { headings } = vars;

const tableItems = {
  lg: {
    columns: [
      {
        header: 'Appraisal #',
        type: 'text',
        field: 'repairorder',
        width: 120,
      },
      {
        header: 'Offers ',
        type: 'text',
        width: 130,
        render: () => (
          <TouchableOpacity>
            <View
              style={{
                width: 110,
                borderRadius: 15,
                backgroundColor: '#2cbcb1',
                alignItems: 'center',
                paddingTop: 5,
                paddingBottom: 5,
              }}
            >
              <Text style={{ ...headings.h8, color: '#FFF' }}>View Offers</Text>
            </View>
          </TouchableOpacity>
        ),
        action: ({ item }) => ({
          type: 'link',
          link: {
            view: ROUTES.simpleList.name,
            params: {
              title: item?.uci?.offerRecieved
                ? 'Offers Received'
                : 'No Offers Received ',
              item: item?.uci?.offerRecieved ? item?.uci?.offerRecieved : [],
            },
          },
        }),
      },
      {
        header: 'Customer Name',
        type: 'text',
        width: 180,
        render: ({ item = {} }) => {
          const name = item?.name.length <= 10
            ? item?.name
            : `${item?.name.substring(0, 10)}...`;

          return (
            <Text
              style={{
                fontSize: 16,
                fontFamily: 'Mulish-Medium',
              }}
            >
              {item?.name ? name : '--'}
            </Text>
          );
        },
      },
      {
        header: 'VIN',
        width: 120,
        render: ({ item = {} }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {item?.vin ? shorten(item?.vin, 10) : '--'}
          </Text>
        ),
      },
      {
        header: 'Mileage',
        type: 'number',
        field: 'mileage',
        width: 120,
      },
      {
        header: 'Generated',
        type: 'date',
        field: 'checkDate',
        width: 120,
      },
      {
        header: 'Original Value',
        width: 120,
        render: ({ item = {} }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {item?.rmbp ? `$${item?.rmbp} ` : '--'}
          </Text>
        ),
      },
      {
        header: 'Spread',
        width: 100,
        render: ({ item = {} }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {item?.ruleSpread ? `${item?.ruleSpread} %` : '--'}
          </Text>
        ),
      },
      {
        header: 'Enhancement',
        width: 130,
        render: ({ item = {} }) => (
          <Text
            style={{
              fontSize: 16,
              fontFamily: 'Mulish-Medium',
            }}
          >
            {item?.ruleEnhancement ? `${item?.ruleEnhancement} %` : '--'}
          </Text>
        ),
      },
      {
        header: 'Range',
        type: 'text',
        field: 'finalrange',
        width: 180,
      },
    ],
  },
};

export default Table({
  uri: listAllUri,
  ...tableItems,
  action: ({ item }) => ({
    type: 'link',
    link: {
      view: ROUTES.viewAppraisalHistory.name,
      params: { item: { ...item }, editable: false },
    },
  }),
});
